import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ungdoMissionImg from '../images/UNGDO Mission.png';
import iconLogoImg from '../images/icon_logo.jpg';
import './Home.css';

function Home({ siteData }) {
  const hero = siteData?.hero || {};
  const focusAreas = Array.isArray(siteData?.focusAreas) ? siteData.focusAreas : [];
  const stats = Array.isArray(siteData?.stats) ? siteData.stats : [];
  const gallery = Array.isArray(siteData?.gallery) ? siteData.gallery : [];
  const bannerSlides = Array.isArray(siteData?.bannerSlides) ? siteData.bannerSlides : [];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (bannerSlides.length <= 1) return undefined;

    const timer = setInterval(() => {
      setActiveSlide((current) => (current + 1) % bannerSlides.length);
    }, 4500);

    return () => clearInterval(timer);
  }, [bannerSlides]);

  const nextSlide = () => {
    setActiveSlide((current) => (current + 1) % bannerSlides.length);
  };

  const prevSlide = () => {
    setActiveSlide((current) => (current - 1 + bannerSlides.length) % bannerSlides.length);
  };

  const fundingProjects = [
    'Residential housing',
    'Civil infrastructure, schools, hospitals & medical centers',
    'Agriculture & rural community development',
    'Fisheries, fishing harbours & processing vessels',
    'Renewable green energy & climate resilience',
    'Transportation, roads & seaports',
    'Water, sanitation & public health',
    'Telecommunications & digital inclusion',
    'Eco-tourism & heritage conservation',
    'Government buy-back rural development projects'
  ];

  return (
    <div className="page-shell">
      {/* Banner Slider */}
      <section className="banner-slider">
        {bannerSlides.map((slide, index) => (
          <div
            key={slide.id || index}
            className={`banner-slide ${index === activeSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="banner-overlay" />
            <div className="banner-content-wrap">
              <div className="banner-content">
                <span className="banner-kicker">
                  <span style={{ fontSize: '0.9rem' }}>🌐</span> UNGDO GLOBAL PORTAL
                </span>
                <h2>{slide.title || 'Global Action for Peace'}</h2>
                <p>{slide.subtitle || 'Supporting communities, education, and sustainable development across borders.'}</p>
                <Link to={slide.ctaLink || '/about'} className="primary-button banner-button">
                  {slide.ctaText || 'Learn More'} →
                </Link>
              </div>
            </div>
          </div>
        ))}

        {bannerSlides.length > 1 && (
          <>
            <button
              type="button"
              className="banner-nav-btn prev"
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              ‹
            </button>
            <button
              type="button"
              className="banner-nav-btn next"
              onClick={nextSlide}
              aria-label="Next slide"
            >
              ›
            </button>

            <div className="slider-dots" aria-label="Banner navigation">
              {bannerSlides.map((slide, index) => (
                <button
                  key={slide.id || index}
                  type="button"
                  className={index === activeSlide ? 'dot active' : 'dot'}
                  onClick={() => setActiveSlide(index)}
                  aria-label={`Show slide ${index + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </section>

      {/* Volunteer & Key Focus Areas Section */}
      <div className="content-wrap contact-layout" style={{ marginTop: '50px', marginBottom: '50px' }}>
        <section className="content-panel info-card-hover">
          <span className="un-pill" style={{ marginBottom: '16px' }}>Impact & Advocacy</span>
          <h2 style={{ color: '#0c2f4d', marginTop: 0, fontSize: '2.4rem', fontWeight: '700', letterSpacing: '-0.5px' }}>
            {hero.title || 'Volunteer for a better world'}
          </h2>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#405a73' }}>
            {hero.subtitle || 'We build partnerships for peace, social development, education, and humanitarian action worldwide.'}
          </p>
          <Link to={hero.ctaLink || '/about'} className="primary-button" style={{ marginTop: '8px', display: 'inline-block' }}>
            {hero.ctaText || 'Explore our mission'} →
          </Link>

          {/* Stat Cards Grid */}
          <div className="stat-grid-enhanced">
            {stats.map((item) => (
              <div className="stat-box-enhanced" key={item.label}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Sidebar Key Focus Areas */}
        <aside>
          <div className="info-card info-card-hover">
            <h3 style={{ color: '#0c2f4d', marginTop: 0, marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>🎯</span> Key Focus Areas
            </h3>
            <ul className="focus-pills-list">
              {focusAreas.map((item, idx) => (
                <li key={idx} className="focus-pill-item">
                  <span className="focus-pill-icon">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>

      {/* About & Infrastructural Funding Section */}
      <div className="content-wrap contact-layout" style={{ marginBottom: '50px' }}>
        <section className="content-panel info-card-hover">
          {/* UNGDO Mission Image Frame */}
          <div className="mission-img-wrap">
            <img src={ungdoMissionImg} alt="United Nations Global Development Organization (UNGDO) Mission led by Dr. Tharindu Wijenayake" />
          </div>

          <p style={{ textAlign: 'center', fontStyle: 'italic', color: '#009edb', marginBottom: '28px', fontSize: '1.05rem', fontWeight: '600' }}>
            —— Legally incorporated in the USA & registered with the United Nations ——
          </p>

          <h3 style={{ color: '#0c2f4d', marginTop: '24px', fontSize: '1.6rem', fontWeight: '700' }}>Our Organization</h3>
          <p style={{ lineHeight: '1.8', color: '#405a73', fontSize: '1rem' }}>
            United Nations Global Development Organization is a non-profitable international organization facilitating the United Nations Sustainable Development Goals globally. The goal of the UNGDO is to cater towards socioeconomic and infrastructural development, spiritual and mental wellness, relief for destitute and disaster victims and rehabilitation, regardless of religion, race, gender, culture and ethnic diversity.
          </p>

          {/* Infrastructural Funding Section */}
          <h3 style={{ color: '#0c2f4d', marginTop: '36px', fontSize: '1.6rem', fontWeight: '700' }}>Infrastructural Funding</h3>
          <p style={{ lineHeight: '1.7', color: '#405a73' }}>
            We arrange funding facilities from our International donors to governments to cover key development sector projects:
          </p>

          {/* Animated 2-Column Grid for Funding Projects */}
          <ul className="funding-grid">
            {fundingProjects.map((item, idx) => (
              <li key={idx} className="funding-item">
                <span className="funding-check">✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Sidebar Widgets */}
        <aside>
          {/* Contact Us Widget */}
          <div className="info-card info-card-hover" style={{ marginBottom: '20px' }}>
            <div style={{ textAlign: 'center', marginBottom: '14px' }}>
              <img
                src={iconLogoImg}
                alt="UNGDO Icon Logo"
                style={{ maxWidth: '85px', height: 'auto', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
            </div>
            <h3 style={{ marginBottom: '14px', color: '#0c2f4d', textAlign: 'center' }}>Contact Us</h3>
            <p style={{ margin: '0 0 8px', color: '#405a73', fontSize: '0.95rem', textAlign: 'center' }}>
              United Nations Global Development Organization Head Office,<br />
              Delaware, USA
            </p>
            <p style={{ margin: '12px 0 0', color: '#009edb', textAlign: 'center' }}>
              <strong>Email:</strong><br />
              <a href="mailto:info@ungdo.org" style={{ color: '#009edb', textDecoration: 'none', fontWeight: '600' }}>info@ungdo.org</a>
            </p>
          </div>

          {/* Hours Widget */}
          <div className="info-card info-card-hover" style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '14px', color: '#0c2f4d' }}>Office Hours</h3>
            <p style={{ margin: '0 0 8px', color: '#405a73', fontSize: '0.95rem' }}>
              <strong>Monday to Friday:</strong> 9:00AM – 5:00PM EST
            </p>
            <p style={{ margin: '8px 0 0', color: '#405a73', fontSize: '0.95rem' }}>
              <strong>Saturday & Sunday:</strong> 11:00AM – 3:00PM EST
            </p>
          </div>

          {/* United Nations Links Widget */}
          <div className="info-card info-card-hover" style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '14px', color: '#0c2f4d' }}>UN Initiatives</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <li>
                <Link to="/united-nations/sdg-interactive" style={{ color: '#009edb', textDecoration: 'none', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <span>➔</span> SDG Interactive
                </Link>
              </li>
              <li>
                <Link to="/united-nations/un-human-rights-declaration" style={{ color: '#009edb', textDecoration: 'none', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <span>➔</span> UN Human Rights Declaration
                </Link>
              </li>
            </ul>
          </div>

          {/* YouTube Video Widget */}
          <div className="info-card info-card-hover">
            <h3 style={{ marginBottom: '14px', color: '#0c2f4d' }}>Featured Video</h3>
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', borderRadius: '12px', overflow: 'hidden', marginBottom: '12px', boxShadow: '0 6px 16px rgba(0,0,0,0.1)' }}>
              <iframe
                src="https://www.youtube.com/embed/f0Qb6_VKrBA"
                title="UNGDO Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <a
              href="https://www.youtube.com/watch?v=f0Qb6_VKrBA"
              target="_blank"
              rel="noopener noreferrer"
              className="primary-button"
              style={{
                display: 'block',
                textAlign: 'center',
                padding: '10px 14px',
                fontSize: '0.88rem',
                textDecoration: 'none'
              }}
            >
              Watch on YouTube ↗
            </a>
          </div>
        </aside>
      </div>

      {/* Gallery Section */}
      <section className="content-panel info-card-hover" style={{ marginTop: '40px', marginBottom: '40px' }}>
        <h3 style={{ color: '#0c2f4d', fontSize: '1.8rem', margin: '0 0 16px', fontWeight: '700' }}>Mission Gallery</h3>
        <div className="home-gallery-grid">
          {gallery.slice(0, 4).map((item) => (
            <figure className="home-gallery-card" key={item.id}>
              <div className="home-gallery-img-wrap">
                <img src={item.image} alt={item.title} />
              </div>
              <figcaption>
                <strong>{item.title}</strong>
                <span>{item.shortDescription || 'A meaningful moment from our community and mission work.'}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
